import React,{useState,useEffect} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';

function ContactAgent({subtitle, title, buttons,sendMessage,btnTypeG, setbtnTypeG, indexLength, arrayLength, scrollToBottom,openMic}) {
    const [openDrawer, setopenDrawer] = useState(false)

    const [searchValue, setSearchValue] = useState("")
    const searchHandler =(e)=>{
        var lowerCase = e.target.value.toLowerCase();
        setSearchValue(lowerCase);
    }
    const filteredData = buttons.filter((el) => {
        if (searchValue === '') {
            return el;
        }
        else {
            return el?.title?.toLowerCase().includes(searchValue)
        }
    })

    const [showBtn, setShowBtn] = useState(true)
    const [btnType, setbtnType] = useState("footer")

    useEffect(()=>{
        if(parseInt(arrayLength?.length-2) > indexLength){
            setShowBtn(false)
        }
    }, [arrayLength])

    const scrollPage =()=>{
        setTimeout(() => {
            scrollToBottom()
        }, 400);
    }
    return (
        <>
            {
                showBtn ?
                    btnTypeG === "chat" ?
                        <button type="button" className="btn-default btn-seprate" onClick={() => setopenDrawer(true)}>{subtitle}</button>
                    :
                        <>
                            {
                                btnType === "footer" ?
                                <div className="appointment-footer-wrapper">
                                    {
                                        openMic ?
                                            <KeyboardVoiceIcon onClick={()=> {setbtnType("chat"); setbtnTypeG("chat"); scrollPage()}} />
                                        :
                                            <KeyboardIcon onClick={()=> {setbtnType("chat"); setbtnTypeG("chat"); scrollPage()}} />       
                                    }
                                    <button type="button" className="btn-default btn-seprate" onClick={() => setopenDrawer(true)}>{subtitle}</button>
                                </div>
                            :
                                <button type="button" className="btn-default btn-seprate" onClick={() => setopenDrawer(true)}>{subtitle}</button>
                            }    
                        </>
                :   
                    <button type="button" className="btn-default btn-seprate btn-disabled" disabled onClick={() => setopenDrawer(true)}>{subtitle}</button>
            }
            {
                openDrawer 
                ?
                    <div className="drawer-overlay" onClick={() => setopenDrawer(false)}></div>
                : 
                    <></>
            }
            <div className={`leave-message-wrapper list-drawer-wrapper ${openDrawer ? "show-leave-form" : ""}`}>
                <div className="green-mark"></div>
                <div className="drawer-header">
                    <input type="text" placeholder="Search here..." className="form-control" value={searchValue} onChange={(e)=>searchHandler(e)} />
                    <SearchIcon />
                </div>
                <div className="drawer-body">
                    <div className="agent-list-wrapper">
                        {   
                            filteredData?.map(buttons=>{
                                return <div className="agent-item" onClick={()=> {sendMessage(buttons);setopenDrawer(false);setShowBtn(false)}}><span>{buttons.title}</span></div>
                            })
                        }
                        {
                            filteredData.length < 1 && <div style={{textAlign:"center"}}>No record found</div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default ContactAgent;
